define("settings/components/subscription-help-list", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul class="tAC--accordion">
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_9")}}
      @title={{t "account.subscription.index.help.title_9"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_1")}}
      @title={{t "account.subscription.index.help.title_1"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_2")}}
      @title={{t "account.subscription.index.help.title_2"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_3")}}
      @title={{t "account.subscription.index.help.title_3"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_4")}}
      @title={{t "account.subscription.index.help.title_4"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_5")}}
      @title={{t "account.subscription.index.help.title_5"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_6")}}
      @title={{t "account.subscription.index.help.title_6"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_7")}}
      @title={{t "account.subscription.index.help.title_7"}}
    />
    <SubscriptionHelpListItem
      @details={{html-safe (t "account.subscription.index.help.details_8")}}
      @title={{t "account.subscription.index.help.title_8"}}
    />
  </ul>
  */
  {
    "id": "NKx5WJkt",
    "block": "[[[10,\"ul\"],[14,0,\"tAC--accordion\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_9\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_9\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_1\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_1\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_2\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_2\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_3\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_3\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_4\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_4\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_5\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_5\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_6\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_6\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_7\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_7\"],null]]],null],[1,\"\\n  \"],[8,[39,0],null,[[\"@details\",\"@title\"],[[28,[37,1],[[28,[37,2],[\"account.subscription.index.help.details_8\"],null]],null],[28,[37,2],[\"account.subscription.index.help.title_8\"],null]]],null],[1,\"\\n\"],[13]],[],false,[\"subscription-help-list-item\",\"html-safe\",\"t\"]]",
    "moduleName": "settings/components/subscription-help-list.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});